import { EnvironmentType } from "@app-context/environments/context";
import { defaultEnvironmentOptions } from "@app-context/environments/EnvironmentsProvider";
import {
  CopyToClipboard,
  FormSectionAccordion,
  IconButton,
  InputLabelControl,
  TextInput,
} from "@enfusion-ui/web-components";
import { errorToast, infoToast, styled } from "@enfusion-ui/web-core";
import { faClone } from "@fortawesome/pro-solid-svg-icons";
import * as React from "react";

const InputWrapper = styled.div`
  flex: 1;

  @media (max-width: 630px) {
    min-width: 45%;
  }
`;

export const SingleRowContainer = styled.div<{
  count?: number;
  noMargin?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ count = 3 }) => `repeat(${count}, 1fr)`};
  grid-column-gap: var(--spacing-xl);
  margin-bottom: ${({ noMargin }) => (noMargin ? "0px" : "var(--spacing-xl)")};
  gap: var(--spacing-xl);
`;

const CopyIcon: React.FC<{ value: string }> = ({ value }) => {
  return (
    <CopyToClipboard
      getText={() => value}
      onSuccess={() => infoToast("Copied to clipboard")}
      onError={() => errorToast("Failed to copy")}
      component={
        <IconButton
          style={{ padding: "2px" }}
          icon={faClone}
          title="Copy to clipboard"
          size="xs"
        />
      }
    />
  );
};

const DefaultEnvRow: React.FC<{ entry: EnvironmentType }> = ({ entry }) => {
  return (
    <SingleRowContainer count={3}>
      <TextInput hideLabel value={entry.label} readOnly />
      <TextInput
        hideLabel
        value={entry.IDPUrl}
        name="idp-url"
        readOnly
        iconContainer={<CopyIcon value={entry.IDPUrl} />}
      />
      <TextInput
        hideLabel
        value={entry.restAPIUrl}
        name="restAPI-url"
        readOnly
        iconContainer={<CopyIcon value={entry.restAPIUrl} />}
      />
    </SingleRowContainer>
  );
};

export const DefaultEnvInputs: React.FC<unknown> = () => {
  return (
    <FormSectionAccordion title="Default Environments" defaultOpen={false}>
      <SingleRowContainer style={{ marginBottom: 0 }}>
        <InputWrapper>
          <InputLabelControl label="Name" />
        </InputWrapper>
        <InputWrapper>
          <InputLabelControl label="IDP URL" />
        </InputWrapper>
        <InputWrapper>
          <InputLabelControl label="API URL" />
        </InputWrapper>
      </SingleRowContainer>
      {defaultEnvironmentOptions.map((e) => (
        <DefaultEnvRow entry={e} key={e.label} />
      ))}
    </FormSectionAccordion>
  );
};
